import '../assets/styles/index.scss';
import { initGame } from './game/game';

// eslint-disable-next-line
const game = initGame();
window.game = game;

screen.orientation.lock( 'portrait' ).catch(err => {});
